import { useEffect, useState } from "react";
import { useOutletContext } from 'react-router-dom';
import axios from "axios";
import Swal from "sweetalert2";
// COMPONENTE
import ZonaCargando from "../alertas/zonaCargando";
// FUNCIONES
import { formatearMoneda } from "../../funcionesDatos/Moneda";

function ConciliacionWompi() {

    const { usuario, cargandoUsuario } = useOutletContext() || {};
    const [cargando, setCargando]     = useState(false);
    const cargandoFinal               = Boolean(cargandoUsuario) || Boolean(cargando);

    const [saldoReal, setSaldoReal]         = useState(0);
    const [saldoEsperado, setSaldoEsperado] = useState(0);
    const [diferencia, setDiferencia]       = useState(0);
    const [detalle, setDetalle]             = useState(null);

    // Formulario para registrar un retiro de la empresa
    const [monto, setMonto]             = useState("");
    const [feeTotal, setFeeTotal]       = useState("");
    const [referenciaPago, setReferenciaPago] = useState("");
    const [notas, setNotas]             = useState("");

    // Formulario para registrar un ajuste manual conocido (positivo o negativo)
    const [montoAjuste, setMontoAjuste] = useState("");
    const [notasAjuste, setNotasAjuste] = useState("");

    function mostrarMoneda(valor) {
        return formatearMoneda(Number(valor || 0), "COP");
    }

    async function obtenerConciliacion() {
        try {
            setCargando(true);
            const res = await axios.post("/conciliacion-wompi");
            const data = res?.data || {};

            setSaldoReal(Number(data?.saldoReal || 0));
            setSaldoEsperado(Number(data?.saldoEsperado || 0));
            setDiferencia(Number(data?.diferencia || 0));
            setDetalle(data?.detalle || null);
        }
        catch (err) {
            console.log("Error obteniendo conciliación:", err);
            await Swal.fire({
                icon: "error",
                title: "No se pudo calcular la conciliación",
                text: err?.response?.data?.mensaje || "Ocurrió un error consultando Wompi.",
                confirmButtonText: "Entendido",
                customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" },
            });
        }
        finally { setCargando(false); }
    }

    useEffect(() => { obtenerConciliacion(); }, []);

    async function registrarRetiro() {
        try {
            if (!monto || Number(monto) <= 0) {
                return Swal.fire({ icon: "error", title: "Falta el monto", text: "Ingresa el monto del retiro.", customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" } });
            }

            setCargando(true);
            await axios.post("/registrar-retiro-empresa", {
                params: { monto: Number(monto), feeTotal: Number(feeTotal || 0), referenciaPago, notas },
            });
            setCargando(false);

            setMonto(""); setFeeTotal(""); setReferenciaPago(""); setNotas("");

            await Swal.fire({
                icon: "success",
                title: "Retiro registrado",
                text: "La conciliación se va a recalcular con este retiro incluido.",
                confirmButtonText: "Continuar",
                customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" },
            });

            await obtenerConciliacion();
        }
        catch (err) {
            console.log("Error registrando retiro:", err);
            setCargando(false);
            await Swal.fire({ icon: "error", title: "No se pudo registrar", text: "Intenta de nuevo.", customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" } });
        }
    }

    async function registrarAjuste() {
        try {
            if (!montoAjuste || Number(montoAjuste) === 0) {
                return Swal.fire({ icon: "error", title: "Falta el monto", text: "Ingresa el monto del ajuste (puede ser negativo).", customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" } });
            }
            if (!notasAjuste.trim()) {
                return Swal.fire({ icon: "error", title: "Falta la nota", text: "Explica por qué existe este ajuste, para no perder el rastro más adelante.", customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" } });
            }

            setCargando(true);
            await axios.post("/registrar-ajuste-conciliacion", {
                params: { monto: Number(montoAjuste), notas: notasAjuste },
            });
            setCargando(false);

            setMontoAjuste(""); setNotasAjuste("");

            await Swal.fire({
                icon: "success",
                title: "Ajuste registrado",
                text: "La conciliación se va a recalcular con este ajuste incluido.",
                confirmButtonText: "Continuar",
                customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" },
            });

            await obtenerConciliacion();
        }
        catch (err) {
            console.log("Error registrando ajuste:", err);
            setCargando(false);
            await Swal.fire({ icon: "error", title: "No se pudo registrar", text: err?.response?.data?.mensaje || "Intenta de nuevo.", customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" } });
        }
    }

    const diferenciaOk = Math.abs(diferencia) < 5000; // margen chico por la retención estimada

    return (
        <div>
            {cargandoFinal ? <ZonaCargando />
            : usuario ?
            <div className="container-fluid">
                <div className="pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2 text-dark mb-1">Conciliación Wompi</h1>
                    <p className="text-secondary mb-0">
                        Compara el saldo real disponible en Wompi contra lo que nuestra base de datos calcula que debería estar.
                    </p>
                </div>

                <div className="row g-3 mb-4">
                    <div className="col-12 col-md-4">
                        <div className="card border-0 shadow-sm rounded-4 h-100">
                            <div className="card-body">
                                <span className="text-secondary fw-semibold">Saldo real (Wompi)</span>
                                <h3 className="fw-bold text-dark mb-0 mt-1">{mostrarMoneda(saldoReal)}</h3>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-4">
                        <div className="card border-0 shadow-sm rounded-4 h-100">
                            <div className="card-body">
                                <span className="text-secondary fw-semibold">Saldo esperado (calculado)</span>
                                <h3 className="fw-bold text-dark mb-0 mt-1">{mostrarMoneda(saldoEsperado)}</h3>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-4">
                        <div className={`card border-0 shadow-sm rounded-4 h-100 ${diferenciaOk ? "" : "border border-danger"}`}>
                            <div className="card-body">
                                <span className="text-secondary fw-semibold">Diferencia</span>
                                <h3 className={`fw-bold mb-0 mt-1 ${diferenciaOk ? "text-success" : "text-danger"}`}>{mostrarMoneda(diferencia)}</h3>
                            </div>
                        </div>
                    </div>
                </div>

                {!diferenciaOk && (
                    <div className="alert alert-danger rounded-4 mb-4">
                        La diferencia es mayor al margen esperado por la retención en la fuente estimada — revisa transacción por transacción antes de asumir que todo está bien.
                    </div>
                )}

                {detalle && (
                <div className="card border-0 shadow-sm rounded-4 mb-4">
                    <div className="card-body">
                        <h6 className="fw-bold mb-3">Desglose del cálculo</h6>
                        <div className="d-flex justify-content-between border-bottom py-1"><span className="text-secondary">Total ventas aprobadas</span><span>{mostrarMoneda(detalle.montoTotalVentas)}</span></div>
                        <div className="d-flex justify-content-between border-bottom py-1"><span className="text-secondary">Fee de pasarela ya descontado</span><span>- {mostrarMoneda(detalle.pasarela)}</span></div>
                        <div className="d-flex justify-content-between border-bottom py-1"><span className="text-secondary">Retención en la fuente (estimada)</span><span>- {mostrarMoneda(detalle.retencionFuente)}</span></div>
                        <div className="d-flex justify-content-between border-bottom py-1 fw-semibold"><span>Neto recibido de ventas</span><span>{mostrarMoneda(detalle.netoRecibidoDeVentas)}</span></div>
                        <div className="d-flex justify-content-between border-bottom py-1"><span className="text-secondary">Capital ya pagado a vendedores</span><span>- {mostrarMoneda(detalle.capitalPagadoVendedores)}</span></div>
                        <div className="d-flex justify-content-between border-bottom py-1"><span className="text-secondary">Fee de Pagos a Terceros (pagos a vendedores)</span><span>- {mostrarMoneda(detalle.feePagosVendedores)}</span></div>
                        <div className="d-flex justify-content-between border-bottom py-1"><span className="text-secondary">Retiros ya hechos a la empresa</span><span>- {mostrarMoneda(detalle.retirosEmpresa)}</span></div>
                        <div className="d-flex justify-content-between border-bottom py-1"><span className="text-secondary">Fee de Pagos a Terceros (retiros a la empresa)</span><span>- {mostrarMoneda(detalle.feeRetirosEmpresa)}</span></div>
                        <div className="d-flex justify-content-between py-1"><span className="text-secondary">Ajustes manuales conocidos</span><span>{Number(detalle.ajustesManuales || 0) >= 0 ? "+ " : "- "}{mostrarMoneda(Math.abs(detalle.ajustesManuales || 0))}</span></div>
                    </div>
                </div>
                )}

                <div className="card border-0 shadow-sm rounded-4 mb-4">
                    <div className="card-body">
                        <h6 className="fw-bold mb-3">Registrar un retiro a la cuenta de la empresa</h6>
                        <p className="text-secondary small mb-3">
                            Regístralo cada vez que muevas plata de Wompi Cuenta hacia el banco de la empresa, para que la conciliación siga siendo exacta.
                        </p>

                        <div className="row g-2">
                            <div className="col-12 col-md-3">
                                <input type="number" className="form-control" placeholder="Monto retirado" value={monto} onChange={(e) => setMonto(e.target.value)} />
                            </div>
                            <div className="col-12 col-md-3">
                                <input type="number" className="form-control" placeholder="Fee cobrado por Wompi" value={feeTotal} onChange={(e) => setFeeTotal(e.target.value)} />
                            </div>
                            <div className="col-12 col-md-3">
                                <input type="text" className="form-control" placeholder="Referencia (opcional)" value={referenciaPago} onChange={(e) => setReferenciaPago(e.target.value)} />
                            </div>
                            <div className="col-12 col-md-3">
                                <input type="text" className="form-control" placeholder="Notas (opcional)" value={notas} onChange={(e) => setNotas(e.target.value)} />
                            </div>
                        </div>

                        <button type="button" className="btn btn-primary rounded-pill px-4 py-2 fw-semibold mt-3" onClick={registrarRetiro}>
                            <i className="bi bi-plus-circle me-2"></i>
                            Registrar retiro
                        </button>
                    </div>
                </div>

                <div className="card border-0 shadow-sm rounded-4 mb-4">
                    <div className="card-body">
                        <h6 className="fw-bold mb-3">Registrar un ajuste manual conocido</h6>
                        <p className="text-secondary small mb-3">
                            Úsalo cuando sepas por qué hay una diferencia que no viene de ninguna reserva (ej. plata de una transacción de prueba de antes de esta herramienta). El monto puede ser negativo.
                        </p>

                        <div className="row g-2">
                            <div className="col-12 col-md-3">
                                <input type="number" className="form-control" placeholder="Monto (+ o -)" value={montoAjuste} onChange={(e) => setMontoAjuste(e.target.value)} />
                            </div>
                            <div className="col-12 col-md-9">
                                <input type="text" className="form-control" placeholder="Nota: por qué existe este ajuste (obligatoria)" value={notasAjuste} onChange={(e) => setNotasAjuste(e.target.value)} />
                            </div>
                        </div>

                        <button type="button" className="btn btn-primary rounded-pill px-4 py-2 fw-semibold mt-3" onClick={registrarAjuste}>
                            <i className="bi bi-plus-circle me-2"></i>
                            Registrar ajuste
                        </button>
                    </div>
                </div>

                <button type="button" className="btn btn-outline-secondary rounded-pill px-4 py-2" onClick={obtenerConciliacion}>
                    <i className="bi bi-arrow-clockwise me-2"></i>
                    Recalcular
                </button>
            </div>
            : null
            }
        </div>
    );
}

export default ConciliacionWompi;
